import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctDecimals, FctValue } from '../../../../Fct/generics';
import { FaLessThanEqual } from 'react-icons/fa';
import { supportedContracts } from '../constants';
export var BetweenEqual = createPlugin({
    protocol: 'TOKEN_VALIDATOR',
    type: 'VALIDATOR',
    method: 'betweenEqual',
    description: 'Check if amountIn is between or equal minAmount and maxAmount',
    supportedContracts: supportedContracts,
    getParams: function () { return ({
        input: {
            to: new FctAddress({}),
            methodParams: {
                minAmount: new FctValue({ destination: 'wei_amount', isPreview: true, icon: FaLessThanEqual }),
                minDecimals: new FctDecimals({}),
                maxAmount: new FctValue({ destination: 'wei_amount', isPreview: true }),
                maxDecimals: new FctDecimals({}),
                amountIn: new FctValue({ destination: 'wei_amount', isPreview: true, icon: FaLessThanEqual }),
                decimalsIn: new FctDecimals({}),
                decimalsOut: new FctDecimals({}),
            },
        },
        output: {
            result: new FctValue({
                description: 'amountIn - minAmount',
                innerIndex: 0,
            }),
        },
    }); },
});
